"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _polished = require("polished");

var _modalStyles = _interopRequireDefault(require("./modal-styles"));

var _templateObject;

function importFonts() {
  var linkId = 'ui-fx-cdn';

  if (typeof window !== 'undefined' && !document.getElementById(linkId)) {
    var linkElement = document.createElement('link');
    var headElement = document.head || document.getElementsByTagName('head')[0]; // modern || IE11

    linkElement.id = linkId;
    linkElement.rel = 'stylesheet';
    linkElement.href = 'https://fx-cdn.northwesternmutual.com/evergreen/fonts/uitk.css';
    headElement.appendChild(linkElement);
  }
}

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n", ";\n  ", "\n  ", ";\n", ";\n"])), (0, _polished.normalize)(), importFonts(), function (_ref) {
  var theme = _ref.theme;

  if (theme.luna) {
    return (0, _styledComponents.css)(["html{body{.ui-base,.ui-base button,.ui-base h1,.ui-base h2,.ui-base h3,.ui-base h4,.ui-base h5,.ui-base h6,.ui-base p,.ui-base input,.ui-base optgroup,.ui-base select,.ui-base textarea{font-family:'Graphik','Helvetica Neue',Helvetica,sans-serif !important;}}}"]);
  }
}, _modalStyles.default);
var _default = GlobalStyle;
exports.default = _default;
//# sourceMappingURL=globalStyle.js.map